import { FirebaseApp, getApp } from "firebase/app";
import { FirebaseAppName } from "./FirebaseAppName";

export function getFirebaseApp(): FirebaseApp {
  return getApp(FirebaseAppName);
}
